import React, { useState, useEffect, Fragment } from 'react';
import { cloneDeep } from 'lodash';
import { Box, Badge, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Tree from './tree';
import RightContainer from './right-container';
import CustomizeSelect from '../common/select-box-filter';
import { PrimaryButton, IconButton, WhiteButton, SourceIcon } from '../common/button';
import { useTranslate, useDataProvider, usePermissions, Loading as LoadingAdmin } from 'react-admin';
import { useDispatch, useSelector } from 'react-redux';
import {
    toggle, changeInfoPages, changeInfoPage, changeTreeData, selectNode, changeCopyData,
    changeCountLatestVersion, saveInfoPage as saveIP, changeInfoPageDirtyStatus, resetInfoPage
} from '../redux/actions/tree-action';
import { dispatchTree, generateRandomString, INFO_PAGE_APP_FUNCTIONS, INFO_PAGE_DIALOG } from '../utils';
import Snackbar from '../common/snackbar';
// Icons
import { SettingsRounded } from '@material-ui/icons';
import icSetting from '../assets/icons/white-cog.png';
import icDelete from '../assets/icons/white-bin.png';
import icPlus from '../assets/icons/white-plus.png';
import Loading from '../common/loading-page';
import DialogAlertSave from '../common/dialog-alert-save';
import { isBlocking } from '../role/actions';
import DialogChooseVersion from './dialog-choose-version';
import Node from '../redux/model/Node';
import DialogConfirm from '../common/dialog-alert-save/dialog';
import DialogCreateInfoPage from './dialog-create-infopage';
import { lightBlue, grey } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
    container: {
        width: '80%',
        marginTop: theme.spacing(4.5),
        marginLeft: theme.spacing(6),
        marginRight: theme.spacing(7),
    },
    header: {
        borderRadius: 10,
        backgroundColor: '#ffffff',
        padding: '9px 10px 11px 10px',
        marginBottom: 20,
        display: 'flex'
    },
    headerLeft: {
        display: 'flex',
        // flexDirection: 'row',
        // alignItems: 'flex-end',
        width: 455
    },
    buttonBoxPreview: {
        borderRadius: 10,
        backgroundColor: '#f3f7fa',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        height: 80,
        paddingLeft: 24,
        paddingRight: 25,
        paddingBottom: 12,
        marginLeft: 'auto'
    },
    buttonBoxRename: {
        borderRadius: 10,
        backgroundColor: '#f3f7fa',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        height: 80,
        paddingLeft: 28,
        paddingRight: 20,
        paddingBottom: 12,
        marginLeft: 'auto',
        width: 350
    },
    buttonBoxSave: {
        borderRadius: 10,
        backgroundColor: '#f3f7fa',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        height: 80,
        paddingLeft: 28,
        paddingRight: 20,
        paddingBottom: 12,
        marginLeft: 'auto',
        width: 350
    },
    buttonBoxEdit: {
        borderRadius: 10,
        backgroundColor: '#f3f7fa',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        height: 80,
        paddingLeft: 28,
        paddingRight: 20,
        paddingBottom: 12,
        marginLeft: 'auto',
        width: 400
    },
    boxContent: {
        display: 'flex',
        // justifyContent: 'space-between',
    },
    button: {
        padding: 5,
        minWidth: 'unset',
        width: 25,
        height: 25,
        backgroundColor: '#ffffff',
        borderRadius: 10,
        border: 'solid 2px #e5f1f8;',
    },
    disabled: {
        cursor: 'pointer',
        borderBottomColor: grey['900'],
        pointerEvents: 'none',
        opacity: 0.4
    },
    enabled: {
        cursor: 'pointer',
        borderBottomColor: lightBlue['100']
    },
}));

function InfoPage() {
    const classes = useStyles();
    const translate = useTranslate();
    const dispatch = useDispatch();
    const dataProvider = useDataProvider();
    const { permissions, loaded } = usePermissions();
    const { saveInfoPage, isEditing, infoPages, selectedInfoPage, tree, countLatestVersion, isDirty } = useSelector(state => state.tree);

    // STATE
    const [infoPageClusterIds, setInfoPageClusterIds] = useState([]);
    const [snackbarBoldText, setSnackbarBoldText] = useState('');
    const [snackbarText, setSnackbarText] = useState('');
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [defaultSystemLanguage, setDefaultSystemLanguage] = useState('');

    const [dialogCreateConfig, setDialogCreateConfig] = useState({
        open: false,
        action: null,
        flag: INFO_PAGE_DIALOG.DEFAULT
    });

    const [confirm, setConfirm] = useState({
        open: false,
        title: '',
        content: '',
        action: {
            label: '',
            onClick: () => { },
            onCancel: () => { },
            onClose: () => { },
        }
    });
    const [openChooseVersion, setOpenChooseVersion] = useState({
        open: false,
        data: null
    });
    // END STATE

    const getTreeData = () => {
        setLoading(true);
        dataProvider('GET_LIST', 'info-language', {
            filter: { infopage: selectedInfoPage.id },
            pagination: { page: 1, perPage: 100 },
            sort: { field: 'createdAt', order: 'DESC' },
        }).then(({ data }) => {
            const result = dispatchTree(data, translate)
            dispatch(changeTreeData(result));
            setLoading(false);
        }).catch(error => console.log('@@@ getTreeData ERROR', error));
    }

    const onChangeInfoPage = (value) => {
        if (value.id === selectedInfoPage.id) return;
        const afterDialog = function () {
            dispatch(changeTreeData([]));
            dispatch(changeInfoPage(value));
            dispatch(selectNode(null));
            dispatch(changeCopyData(null));
            onCloseConfirm();
        }

        if (isEditing && isDirty) {
            setConfirm({
                open: true,
                title: translate('resources.role.TitleUnsave'),
                content: translate('resources.role.ConstTentUnsave'),
                action: {
                    label: translate('pos.common.save'),
                    onClick: () => {
                        onCloseConfirm();
                        onSave(afterDialog);
                    },
                    onCancel: afterDialog,
                    onClose: onCloseConfirm
                }
            });
        } else {
            afterDialog();
        }
    }

    const mapNewTreeWithoutSelected = (tree) => {
        const result = cloneDeep(tree);

        const recursive = (array = []) => {
            if (!array) return;
            for (let i = 0; i < array.length; i++) {
                array[i].selected = false;
                recursive(array[i].children);
            }
        }

        for (let i = 0; i < result.length; i++) {
            recursive(result[i].children);
            result[i].selected = false;
            result[i].expand = false;
            result[i].expandIds = [];
        }

        return result;
    }

    const deleteUnusedNodeApplicationsFromTree = (cloneTree) => {
        const recursive = (array = []) => {
            for (let j = 0; j < array.length; j++) {
                if (array[j].applicationData?.nodeApplication?.func) {
                    let funcId = array[j].applicationData.nodeApplication.func.id;
                    if (funcId !== INFO_PAGE_APP_FUNCTIONS.START_INACTIVE_BROWSER) {
                        delete array[j].applicationData.nodeApplication.startInactiveBrowser;
                    }
                    if (funcId !== INFO_PAGE_APP_FUNCTIONS.WEATHER) {
                        delete array[j].applicationData.nodeApplication.weatherLocation;
                    }
                    if (funcId !== INFO_PAGE_APP_FUNCTIONS.GENERIC_MEDIA) {
                        delete array[j].applicationData.nodeApplication.genericMediaItem;
                    }
                    if (funcId !== INFO_PAGE_APP_FUNCTIONS.GENERIC_QR_CASTER) {
                        delete array[j].applicationData.nodeApplication.genericQRCaster;
                    }
                    if (funcId !== INFO_PAGE_APP_FUNCTIONS.PLAY_MOVIE) {
                        delete array[j].applicationData.nodeApplication.movie;
                    }
                    if (funcId !== INFO_PAGE_APP_FUNCTIONS.SERVICE_CALL) {
                        delete array[j].applicationData.nodeApplication.serviceCall;
                    }
                    if (funcId !== INFO_PAGE_APP_FUNCTIONS.SLIDE_SHOW) {
                        delete array[j].applicationData.nodeApplication.slideShow;
                    }
                    if (funcId !== INFO_PAGE_APP_FUNCTIONS.LAUNCH_TV_APP) {
                        delete array[j].applicationData.nodeApplication.tvApp;
                    }
                    if (funcId !== INFO_PAGE_APP_FUNCTIONS.MEDIA_GRID) {
                        delete array[j].applicationData.nodeApplication.mediaGrid;
                    }
                    if (funcId !== INFO_PAGE_APP_FUNCTIONS.RADIO) {
                        delete array[j].applicationData.nodeApplication.radio;
                    }
                    if (funcId !== INFO_PAGE_APP_FUNCTIONS.REMOTE_SITE_LAUNCHER) {
                        delete array[j].applicationData.nodeApplication.remoteSiteLauncher;
                    }
                    if (funcId !== INFO_PAGE_APP_FUNCTIONS.RSS) {
                        delete array[j].applicationData.nodeApplication.Rss;
                    }
                }
                
                if (array[j].children) {
                    recursive(array[j].children);
                }
            }
        }
        
        for (let i = 0; i < cloneTree.length; i++) {
            recursive(cloneTree[i].children);
        }
    }

    const onSave = (cb) => {
        setSaving(true);
        const newTree = mapNewTreeWithoutSelected(tree);
        dispatch(changeInfoPageDirtyStatus(false));

        // Optimize saving data
        deleteUnusedNodeApplicationsFromTree(newTree);

        dataProvider('UPDATE', `info-page/save`, {
            id: selectedInfoPage.id,
            data: {
                trees: newTree,
                version: parseFloat(localStorage.getItem('infoPageDraftVersion'))
            }
        }).then(({ data }) => {
            console.log('@@@ UPDATE TV_MENU SUCCESS:', data);
            if (saveInfoPage.status !== null) {
                dispatch(saveIP({ status: 'Previewing', id: data.id }))
            } else {
                setSnackbarBoldText(selectedInfoPage.name);
                setTimeout(() => {
                    setSnackbarBoldText('');
                }, 4000);
            }
            localStorage.setItem('infoPageDraftVersion', data.version)
            // getTreeData(data)
        }).catch(({ message }) => {
            // TODO: Should show error message
            showSnackbarWithText(translate(message));
        }).finally(() => {
            setSaving(false);
            if (typeof cb === 'function') cb();
        });
    }

    const checkNodeType = (data) => {
        const node = new Node();
        node.nodeType = data.applicationData.nodeType;
        node.preview = data.applicationData.preview;
        node.nodeApplication.func = data.applicationData.nodeApplication.func;
        switch (data.applicationData.nodeType) {
            case 'Info':
                node.nodeInfo = data.applicationData.nodeInfo;
                break;
            case 'Linked Menu':
                node.nodeLinkedMenu = data.applicationData.nodeLinkedMenu;
                break;
            case 'Application':
                switch (node.nodeApplication.func.id) {
                    case INFO_PAGE_APP_FUNCTIONS.GENERIC_MEDIA:
                        node.nodeApplication.genericMediaItem = data.applicationData.nodeApplication.genericMediaItem;
                        break;
                    case INFO_PAGE_APP_FUNCTIONS.RSS:
                        node.nodeApplication.Rss = data.applicationData.nodeApplication.Rss;
                        break;
                    case INFO_PAGE_APP_FUNCTIONS.GENERIC_QR_CASTER:
                        node.nodeApplication.genericQRCaster = data.applicationData.nodeApplication.genericQRCaster;
                        break;
                    case INFO_PAGE_APP_FUNCTIONS.LAUNCH_TV_APP:
                        node.nodeApplication.tvApp = data.applicationData.nodeApplication.tvApp;
                        break;
                    case INFO_PAGE_APP_FUNCTIONS.MEDIA_GRID:
                        node.nodeApplication.mediaGrid = data.applicationData.nodeApplication.mediaGrid;
                        break;
                    case INFO_PAGE_APP_FUNCTIONS.PLAY_MOVIE:
                        node.nodeApplication.movie = data.applicationData.nodeApplication.movie;
                        break;
                    case INFO_PAGE_APP_FUNCTIONS.REMOTE_SITE_LAUNCHER:
                        node.nodeApplication.remoteSiteLauncher = data.applicationData.nodeApplication.remoteSiteLauncher;
                        break;
                    case INFO_PAGE_APP_FUNCTIONS.SERVICE_CALL:
                        node.nodeApplication.serviceCall = data.applicationData.nodeApplication.serviceCall;
                        break;
                    case INFO_PAGE_APP_FUNCTIONS.SLIDE_SHOW:
                        node.nodeApplication.slideShow = data.applicationData.nodeApplication.slideShow;
                        break;
                    case INFO_PAGE_APP_FUNCTIONS.START_INACTIVE_BROWSER:
                        node.nodeApplication.startInactiveBrowser = data.applicationData.nodeApplication.startInactiveBrowser;
                        break;
                    case INFO_PAGE_APP_FUNCTIONS.WEATHER:
                        node.nodeApplication.weatherLocation = data.applicationData.nodeApplication.weatherLocation;
                        break;
                    case INFO_PAGE_APP_FUNCTIONS.RADIO:
                        node.nodeApplication.radio = data.applicationData.nodeApplication.radio;
                        break;
                    case INFO_PAGE_APP_FUNCTIONS.EXTERNAL_SERVICES:
                        node.nodeApplication.externalServices = data.applicationData.nodeApplication.externalServices;
                        break;
                    default:
                        break;
                }
                break;
            default:
                break;
        }
        data.applicationData = node;
    }

    const onPublish = () => {
        setSaving(true);
        onCloseConfirm();
        dispatch(changeInfoPageDirtyStatus(false));
        const recursive = (array = []) => {
            for (let j = 0; j < array.length; j++) {
                checkNodeType(array[j])
                recursive(array[j].children)
            }
        }

        const treeData = cloneDeep(tree)
        for (let i = 0; i < treeData.length; i++) {
            for (const key in treeData[i].children[0].data) {
                treeData[i][key] = treeData[i].children[0].data[key];
            }
            treeData[i].children = treeData[i].children[0].children
            treeData[i].nodeName = treeData[i].language.name

            recursive(treeData[i].children)
        }

        // Optimize saving data
        deleteUnusedNodeApplicationsFromTree(treeData);

        dataProvider('UPDATE', `info-page/publish`, {
            id: selectedInfoPage.id,
            data: { data: treeData }
        }).then(({ message }) => {
            showSnackbarWithText(translate(message));
            getListInfoPages();
        }).catch(({ message, version }) => {
            if (version) {
                localStorage.setItem('infoPageDraftVersion', version)
            }
            showSnackbarWithText(translate(message));
        }).finally(() => {
            setSaving(false)
            dispatch(changeCountLatestVersion(0));
        });
    }

    const getListInfoPages = () => {
        dataProvider('GET_LIST', 'info-page-list', {
            sort: { field: 'name', order: 'ASC' },
            pagination: { page: 1, perPage: 100 },
            filter: {}
        }).then(({ data }) => {
            dispatch(changeInfoPages(data));
            dispatch(selectNode(null))
            const selectedInfoPageID = parseInt(localStorage.getItem('selectedInfoPage'))
            if (!selectedInfoPageID) {
                dispatch(changeInfoPage(data[0]));
            }
            else {
                let checkValidInfoPage = true
                let index = 0
                for (let i = 0; i < data.length; i++) {
                    if (data[i].id !== selectedInfoPageID) {
                        checkValidInfoPage = false
                        index = 0
                    }
                    else {
                        checkValidInfoPage = true
                        index = i
                        break;
                    }
                }
                dispatch(changeInfoPage(data[index]));
            }
        }).catch(error => console.error('get-list-info-pages', error));
    }

    const checkInfoPageVersion = () => {
        if (selectedInfoPage) {
            setLoading(true);
            dataProvider('GET_ONE', 'info-page/check-info-page-version', {
                id: selectedInfoPage.id
            }).then(({ data }) => {
                const { hasDraftVersion, infoPage, countVersion, version } = data;
                if (infoPage) {
                    infoPage.data.forEach(item => item.expandIds = []);
                }
                dispatch(changeCountLatestVersion(countVersion));
                localStorage.setItem('infoPageDraftVersion', selectedInfoPage.version)
                if (hasDraftVersion) {
                    localStorage.setItem('infoPageDraftVersion', infoPage.version)
                    if (selectedInfoPage.version < infoPage.version) {
                        dispatch(changeTreeData(infoPage.data));
                    } else {
                        if (infoPage.keepVersion) {
                            dispatch(changeTreeData(infoPage.data));
                        } else {
                            setOpenChooseVersion({
                                open: true,
                                data: infoPage.data
                            });
                        }
                    }
                    setLoading(false);
                } else {
                    const versionLocal = parseFloat(localStorage.getItem('infoPageDraftVersion'))
                    if (versionLocal && version > versionLocal)
                        dispatch(changeCountLatestVersion(1));
                    else
                        getTreeData();
                }
            }).catch(error => console.error('info-page/check-info-page-version:', error));
        }
    }

    const onConfirmChooseVersion = (value) => {
        setOpenChooseVersion({
            ...openChooseVersion,
            open: false
        });
        if (value) {
            dispatch(changeTreeData(openChooseVersion.data));
            updateInfoPageDraftVersion();
        } else {
            // Using the publish data
            deleteInfoPageDraft();
            getTreeData();
            dispatch(changeCountLatestVersion(0));
        }
    }

    const deleteInfoPageDraft = () => {
        dataProvider('DELETE', 'info-page-draft/delete', {
            id: selectedInfoPage.id
        }).then(({ data }) => {
            console.log('DELETE INFO PAGE DRAFT:', data);
        }).catch(error => console.error('DELETE INFO PAGE DRAFT:', error));
    }

    const updateInfoPageDraftVersion = () => {
        dataProvider('UPDATE', 'info-page-draft/update-version', {
            id: selectedInfoPage.id
        }).then(({ data }) => {
            console.log('!!! UPDATE INFO PAGE DRAFT VERSION:', data);
        }).catch(error => console.error('UPDATE INFO PAGE DRAFT VERSION:', error));
    }

    const saveInfoPageName = (newInfoPageName) => {
        dataProvider('UPDATE', 'info-page', {
            id: selectedInfoPage.id,
            data: { name: newInfoPageName }
        }).then(({ data }) => {
            dispatch(changeInfoPage(data));
            const newListInfoPages = infoPages.map(item => ({
                ...item,
                name: item.id === data.id ? data.name : item.name
            }));
            dispatch(changeInfoPages(newListInfoPages));
            showSnackbarWithText(translate('pos.common.renameInfoPage'));
            onCloseDialogInfoPage();
        }).catch(({ message }) => {
            showSnackbarWithText(translate(message));
        });
    }

    const cloneInfoPage = (infoPageName, template) => {
        const cloneTree = cloneDeep(tree)
        for (let i = 0; i < cloneTree.length; i++) {
            cloneTree[i].id = `lang_${cloneTree[i].language.id}`
            cloneTree[i].children[0].expand = false
            cloneTree[i].children[0].id = 'main_' + generateRandomString(5)
            cloneTree[i].children[0].isShowNameInput = false
            cloneTree[i].children[0].nodeName = "Main"
            const recursiveChangeId = (array = [], id = Number) => {
                array.id = generateRandomString(5)
                array.parentMenu = id.includes('main_') ? null : id;
                if (array.code) array.code = null;
                if (array.children)
                    for (let j = 0; j < array.children.length; j++) {
                        recursiveChangeId(array.children[j], array.id)
                    }
            }
            if (cloneTree[i].children[0].children)
                for (let j = 0; j < cloneTree[i].children[0].children.length; j++) {
                    recursiveChangeId(cloneTree[i].children[0].children[j], cloneTree[i].children[0].id)
                }
        }

        for (let i = 0; i < cloneTree.length; i++) {
            for (const key in cloneTree[i].children[0].data) {
                cloneTree[i][key] = cloneTree[i].children[0].data[key];
            }
            cloneTree[i].children = cloneTree[i].children[0].children
            cloneTree[i].nodeName = cloneTree[i].language.name
        }

        dataProvider('CREATE', 'info-page-clone', {
            data: {
                name: infoPageName,
                template: template.id,
                data: cloneTree
            }
        }).then(({ data }) => {
            data.template = template;
            afterCreateOrCloneInfoPage(data);
            showSnackbarWithText(translate('pos.common.cloneInfoPage'));
        }).catch(response => {
            // TODO: Should show error message
            console.error('Cannot create:', response);
        });
    }

    const showSnackbarWithText = (text) => {
        setSnackbarText(text);
        setTimeout(() => {
            setSnackbarText('');
        }, 4000);
    }

    const getLisSetting = () => {
        dataProvider('GET_LIST', "settings", {
            filter: {
                cluster: null,
                room: null,
                name: 'Default System Language'
            },
            sort: {},
            pagination: {}
        }).then(({ data }) => {
            setDefaultSystemLanguage(data)
        })
    }


    const handleCreateInfoPage = (infoPageName, template) => {
        dataProvider('CREATE', 'info-page-create', {
            data: {
                name: infoPageName,
                template: template.id,
                language: defaultSystemLanguage
            }
        }).then(({ data }) => {
            data.template = template;
            afterCreateOrCloneInfoPage(data);
            showSnackbarWithText(translate('pos.common.createInfoPage'));
            onCloseDialogInfoPage();
        }).catch(response => {
            // TODO: Should show error message
            console.error('Cannot create:', response);
        });
    }

    const afterCreateOrCloneInfoPage = (newInfoPage) => {
        const newListInfoPages = [...infoPages, newInfoPage];
        dispatch(changeInfoPages(newListInfoPages));
        dispatch(changeInfoPage(newInfoPage));
        onCloseDialogInfoPage();
        // setBoxName(INFO_PAGE_DIALOG.DEFAULT);
    }

    const handleClickRenameInfoPage = () => {
        setDialogCreateConfig({
            open: true,
            flag: INFO_PAGE_DIALOG.RENAME,
            action: saveInfoPageName,
        });
    }

    const onCloseDialogInfoPage = () => {
        setDialogCreateConfig({
            ...dialogCreateConfig,
            open: false,
        });
    }

    const handleDeleteInfoPage = () => {
        onCloseConfirm();
        setSaving(true);
        dataProvider('DELETE', 'info-page', {
            id: selectedInfoPage.id,
        }).then(() => {
            dispatch(toggle(false));
            const newInfoPages = infoPages.filter(item => item.id !== selectedInfoPage.id);
            dispatch(changeInfoPages(newInfoPages));
            if (newInfoPages.length > 0) {
                dispatch(changeInfoPage(newInfoPages[0]));
            }
            showSnackbarWithText(translate('resources.infoPage.delete_info_page_success'));
        }).catch(error => {
            console.error('Cannot delete info page:', error)
        }).finally(() => setSaving(false));
    }

    const onCancelEdit = () => {
        if (isDirty) {
            const callback = () => {
                checkInfoPageVersion();
                dispatch(selectNode(null));
                dispatch(toggle(false));
                dispatch(changeInfoPageDirtyStatus(false));
                onCloseConfirm();
            }

            setConfirm({
                open: true,
                title: translate('resources.infoPage.cancel_changes'),
                content: translate('resources.infoPage.confirm_cancel_changes'),
                action: {
                    label: translate('pos.common.okay'),
                    onClick: callback,
                    onCancel: onCloseConfirm,
                    onClose: onCloseConfirm
                }
            });
        } else {
            dispatch(toggle(false));
        }
    }

    const getLatestInfoPageVersion = () => {
        setConfirm({
            ...confirm,
            open: false
        });
        getTreeData();
        dispatch(changeCountLatestVersion(0));
        dispatch(selectNode(null));
        // dispatch(changeInfoPageDirtyStatus(true));
        localStorage.setItem('infoPageDraftVersion', null)
        dataProvider('DELETE', 'info-page-draft', {
            id: selectedInfoPage.id,
        }).then(() => {
            console.log('OK')
        }).catch(error => {
            console.error('Cannot delete info page:', error)
        })
    }

    const showDeleteConfirm = () => {
        setConfirm({
            open: true,
            title: translate('resources.infoPage.delete_info_page_title'),
            content: translate('pos.user.contentDelete'),
            action: {
                label: translate('pos.common.delete'),
                onClick: handleDeleteInfoPage,
                onCancel: onCloseConfirm
            }
        });
    }

    const showPublishConfirm = () => {
        setConfirm({
            open: true,
            title: translate('resources.infoPage.publish_info_page_title'),
            content: translate('resources.infoPage.publish_info_page_success'),
            action: {
                label: translate('pos.common.publish'),
                onClick: onPublish,
                onCancel: onCloseConfirm
            }
        });
    }

    const showGetLatestVersionConfirm = () => {
        setConfirm({
            open: true,
            title: translate('resources.infoPage.get_latest_version'),
            content: translate('resources.infoPage.get_latest_version_content'),
            action: {
                label: translate('pos.common.okay'),
                onClick: getLatestInfoPageVersion,
                onCancel: onCloseConfirm
            }
        });
    }

    const onCloseConfirm = () => {
        setConfirm({
            ...confirm,
            open: false
        });
    }

    const handleOpenDialogCreate = () => {
        setDialogCreateConfig({
            open: true,
            flag: INFO_PAGE_DIALOG.CREATE,
            action: handleCreateInfoPage,
        });
    }

    const handleOpenDialogClone = () => {
        setDialogCreateConfig({
            open: true,
            flag: INFO_PAGE_DIALOG.CLONE,
            action: cloneInfoPage,
        });
    }

    const getUserClusterInfoPage = () => {
        dataProvider('GET_LIST', 'info-page-cluster', {
            sort: {},
            pagination: {},
            filter: {}
        }).then(({ data }) => {
            setInfoPageClusterIds(data)
        }).catch(error => console.error('get-list-info-pages-cluster', error));
    }

    useEffect(() => {
        getUserClusterInfoPage();
        getListInfoPages();
        getLisSetting();
        return () => {
            dispatch(resetInfoPage());
        }
    }, []);

    useEffect(() => {
        if (saveInfoPage.status === 'Saving') {
            onSave();
        }
    }, [saveInfoPage])

    useEffect(() => {
        checkInfoPageVersion();
        dispatch(changeInfoPageDirtyStatus(false));
        if (selectedInfoPage) {
            localStorage.setItem('selectedInfoPage', selectedInfoPage.id)
        }
    }, [selectedInfoPage]);

    useEffect(() => {
        dispatch(isBlocking(isDirty));
    }, [isDirty]);

    return loaded ? (
        <DialogAlertSave onSave={onSave}>
            <DialogCreateInfoPage
                onClose={onCloseDialogInfoPage}
                config={dialogCreateConfig}
            />
            <DialogConfirm confirm={confirm} />
            <Loading show={saving} />
            <DialogChooseVersion
                open={openChooseVersion.open}
                onClose={onConfirmChooseVersion}
            />
            <Box width='100%' display='flex' justifyContent='center'>
                <Box className={classes.container}>
                    <Box className={classes.header}>
                        <Box className={classes.headerLeft}>
                            <Box style={{ flex: 0.8, marginRight: 24, paddingTop: 32 }}>
                                <CustomizeSelect
                                    label={translate('resources.infoPage.infoPage')}
                                    data={infoPages}
                                    value={selectedInfoPage ? selectedInfoPage.name : ''}
                                    onChange={onChangeInfoPage}
                                    keyName='name'
                                    placeholder={translate('resources.infoPage.filter_info_page')}
                                    bgcolor='#f3f7fa'
                                    disabled={loading}
                                />
                            </Box>
                            <Box style={{ flex: 0.21 }} position="relative">
                                {
                                    (selectedInfoPage && infoPageClusterIds.find(item => item === selectedInfoPage.id)
                                        && permissions.functionAction.find(value => value.function === 'Cluster info page admin' && value.isUpdate) && !isEditing) ?
                                        <Button
                                            disabled={!selectedInfoPage}
                                            style={{ position: "absolute", top: 56 }}
                                            variant='contained'
                                            color='primary'
                                            onClick={() => { dispatch(toggle(true)) }}
                                        >
                                            {translate('pos.common.edit')}
                                        </Button>
                                        : (permissions.functionAction.find(value => value.function === 'Info pages' && value.isUpdate && !isEditing) && (
                                            <PrimaryButton
                                                disabled={!selectedInfoPage}
                                                style={{ position: "absolute", top: 56 }}
                                                label={translate('pos.common.edit')}
                                                onClick={() => { dispatch(toggle(true)) }}
                                            />
                                        ))
                                }
                                {
                                    isEditing && (
                                        <Fragment>
                                            <Box style={{ position: "absolute", top: 8 }}>
                                                <Badge badgeContent={countLatestVersion > 0 ? "!" : 0} color="error">
                                                    <WhiteButton
                                                        label={translate('resources.infoPage.get_latest_version')}
                                                        onClick={showGetLatestVersionConfirm}
                                                    />
                                                </Badge>
                                            </Box>
                                            <WhiteButton
                                                style={{ position: "absolute", top: 56 }}
                                                label={translate('pos.common.cancelEdit')}
                                                onClick={onCancelEdit}
                                            />
                                        </Fragment>
                                    )
                                }
                            </Box>
                        </Box>
                        {
                            isEditing ?
                                (
                                    <Fragment>
                                        <Box className={classes.buttonBoxSave}>
                                            <Box className={loading ? classes.disabled : classes.enabled}>
                                                <IconButton
                                                    label={translate('pos.common.rename')}
                                                    onClick={() => handleClickRenameInfoPage()}
                                                    endIcon={<SourceIcon source={icSetting} />}
                                                    style={{ marginRight: 10 }}
                                                />
                                                <IconButton
                                                    label={translate('pos.common.delete')}
                                                    onClick={showDeleteConfirm}
                                                    endIcon={<SourceIcon source={icDelete} />}
                                                />
                                            </Box>

                                            <Box className={loading ? classes.disabled : classes.enabled}>
                                                <PrimaryButton label={translate('pos.common.save')} onClick={() => onSave()} style={{ marginRight: 10 }} />
                                                <PrimaryButton label={translate('pos.common.publish')} onClick={showPublishConfirm} disabled={selectedInfoPage ? false : true} />
                                            </Box>
                                        </Box>
                                    </Fragment>
                                ) : (
                                    <Fragment>
                                        {
                                            permissions.functionAction.find(value => value.function === 'Info pages' && value.isUpdate) &&
                                            <Box className={classes.buttonBoxPreview} >
                                                <Box className={loading ? classes.disabled : classes.enabled}>
                                                    <IconButton
                                                        label={translate('resources.infoPage.clone')}
                                                        onClick={() => handleOpenDialogClone()}
                                                        style={{ marginRight: 10 }}
                                                        endIcon={<SettingsRounded />}
                                                    />
                                                </Box>
                                                <Box className={loading ? classes.disabled : classes.enabled}>
                                                    <IconButton
                                                        label={translate('resources.infoPage.createNew')}
                                                        onClick={() => handleOpenDialogCreate()}
                                                        style={{ marginRight: 10 }}
                                                        endIcon={<SourceIcon source={icPlus} />}
                                                    />
                                                </Box>
                                            </Box>
                                        }
                                    </Fragment>
                                )
                        }
                    </Box>
                    <Snackbar
                        show={snackbarBoldText !== ''}
                        boldText={snackbarBoldText}
                        message={translate('resources.infoPage.saveInfoPage')}
                        onClose={() => setSnackbarBoldText('')}
                    />
                    <Snackbar
                        show={snackbarText.length > 0}
                        message={snackbarText}
                        onClose={() => setSnackbarText('')}
                    />
                    <Box className={classes.boxContent}>
                        <Box>
                            <Tree defaultSystemLanguage={defaultSystemLanguage} />
                        </Box>
                        <RightContainer setConfirm={setConfirm} onCloseConfirm={onCloseConfirm} />
                    </Box>
                    {loading && <LoadingAdmin />}
                </Box>
            </Box >
        </DialogAlertSave>
    ) : <LoadingAdmin />;
}

export default InfoPage;
